import React from "react";
import { Box, Typography, Button } from "@mui/material";
import companyVisionStyle from "./companyVisionStyle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import visionImg from "../../../../assets/images/CompanyVision.jpg";
import { scrollToProjectEnd } from "../../../../utils/scrollToProjectEnd";

const CompanyVision = ({ onClose }) => {
  const classes = companyVisionStyle();

  return (
    <Box className={`${classes.detailsContainer} ${classes.fadeIn}`}>
      <Box className={classes.detailsSection}>

        {/* Section Title */}
        <Typography className={classes.header}>
          Herzog & de Meuron’s Vision
        </Typography>

        {/* First Row */}
        <Typography className={classes.fullWidthParagraph}>
          Herzog & de Meuron, commissioned by the Büschl Group, is developing a master plan for the Paketposthalle site.
          The plan seeks to transform the area into a vibrant, mixed-use urban quarter while
          preserving the heritage-listed hall as a public space for cultural and social events.
          New architectural elements will be incorporated to enhance the site's functionality and aesthetics.
        </Typography>

        {/* Second Row */}
        <Box className={classes.textContainer}>
          {/* Left Column */}
          <Box className={classes.textColumn}>
            <Typography className={classes.subHeading}>
              Paketposthalle
            </Typography>
            <Typography className={classes.paragraph}>
              Herzog & de Meuron’s master plan envisions the Paketposthalle
              as a dynamic public space that preserves its historic structure while transforming it into a hub for community life.
              The hall will retain its original raw concrete design, with the removal of the old mail distribution setup creating
              a large, open area for public use.
            </Typography>
            <Typography className={classes.paragraph}>
              It will function as a covered gathering place for cultural events, social activities, and neighborhood gatherings.
              Additionally, new underground facilities, including a concert hall, event spaces, and conference rooms, will expand
              its role as a venue for performances, exhibitions, and meetings.
            </Typography>
          </Box>

          {/* Right Column */}
          <Box className={classes.textColumn}>
            <Typography className={classes.subHeading}>
              New Towers
            </Typography>
            <Typography className={classes.paragraph}>
              Two 155-meter-high towers will be built southwest of the Paketposthalle,
              framing the historic hall and establishing a new Munich landmark. Designed for mixed use, they will include residential,
              office, and retail spaces, along with a hotel, restaurants, and childcare facilities.
            </Typography>
            <Typography className={classes.paragraph}>
              Publicly accessible spaces will also include the ground floors, top levels, and an observation deck in the eastern
              tower, offering panoramic city views. Vertical connectivity will be enhanced with elevators linking the public plaza
              to the upper floors, integrating modern urban living with public accessibility and reinforcing Paketposthalle’s
              role as a central hub for work, leisure, and community life.
            </Typography>
          </Box>
        </Box>

        {/* Image Below */}
        <Box className={classes.imageContainer}>
          <Box className={classes.detailsImage} style={{ backgroundImage: `url(${visionImg})` }} />
          <Typography variant="caption" className={classes.imageCopyright}>
            © Rendering by Herzog & de Meuron (Includes material from Google)
          </Typography>
        </Box>

        {/* Collapse Button */}
        <Button className={classes.collapseButton} onClick={() => scrollToProjectEnd(onClose)}>
          <ExpandLessIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default CompanyVision;
